import requestCountry from 'js/lib/requestCountry';

import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';

/**
 * 3D Secure is enabled for the following countries:
 * - Europe Countries
 * - United Kingdom (GB)
 */
const THREEDS_ENABLED_COUNTRIES = [
  'AD',
  'AT',
  'BE',
  'BG',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'XK',
  'LV',
  'LU',
  'MT',
  'MC',
  'ME',
  'NL',
  'PT',
  'SM',
  'SK',
  'SI',
  'ES',
  'VA',
  'GB',
];

export const getIsThreeDSecureEnabled = (cart?: CartsV2 | null, isSubscriptionUpdate?: boolean) => {
  const is3DSEnabledCountry = THREEDS_ENABLED_COUNTRIES.includes(requestCountry.get());

  if (!cart && isSubscriptionUpdate) {
    return false;
  } else if (!cart) {
    throw new Error('Unable to determine 3D Secure enabled status');
  }

  const isEnabled = is3DSEnabledCountry && !cart.isEnterpriseContract;

  return isEnabled;
};
